import { MutualFundTradingServiceStrategy } from './mutualfund-trading-service-strategy.service';
import { TRADING_PLATFORM } from '../../utils/trading-constants';
import { CdscFeeRequestWrapper, CdscFee, MutualfundTradingOrder } from '../../models/mutualfund/trading-mutualfund.model';
import { Observable } from 'rxjs';
import { TransactionType, Account, AccountType } from '../../models/common/trading-common.model';
import { Injectable } from "@angular/core";
import { HttpHeaders } from '@angular/common/http';


const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    })
};
@Injectable()
export class RetailMutualFundTradingServiceStrategy extends MutualFundTradingServiceStrategy {
    private static SUPPORTED_PLATFORM = TRADING_PLATFORM.RETAIL;

    support(platform: string): boolean {
        return RetailMutualFundTradingServiceStrategy.SUPPORTED_PLATFORM === platform;
    }

    public getAccountTypes(account: Account, transactionType: TransactionType): AccountType[] {
        const isMarginEnabledAccount: boolean = account.marginEligibleInd === 'Y';
        if ( transactionType === TransactionType.BUY ) {
            return [AccountType.CASH];
        }

        if ( isMarginEnabledAccount) {
            return [AccountType.CASH, AccountType.MARGIN];
        }
        return [AccountType.CASH];

    }

    public getCdscFee(cdscFeeRequestWrapper: CdscFeeRequestWrapper): Observable<CdscFee> {
        throw new Error('CDSC Fee is not supported on the retail platform');
    }

    public getLoiRoaDetails(acctNum: string, symbol: string, cusip: string, type: string): Observable<any> {
        throw new Error('LOI/ROA Detail is not supported on the retail platform');
    }

    public editMutualFundOrder(mutualFundTradingOrder: MutualfundTradingOrder): Observable<any> {
        return this.http.post(this.getBaseUrl() + '/edit', mutualFundTradingOrder, httpOptions);
    }


    public getTransactionTypes(account: Account): TransactionType[] {
        // Confirmed that transaction types are the same for retail and pro,
        // with no special handling based on account properties like with Equities
        let data: TransactionType[] = [];
        let isTRP = account.ibdId.toUpperCase() === '30A';
        data.push(TransactionType.BUY);

        if (isTRP) {
            if (!!account && !!account.bankABANum && !!account.bankDDANum && !!account.prodCd && account.prodCd === 'AM') {
                data.push(TransactionType.BUY_MONEY_MARKET_SWEEP);
            }
        }

        // TODO - Need confirm!
        // Exchange transactions aren't allowed in a Level 4 Plan 529 account
        if ( !account || !account.beingTradedInLevel4PlanAcct ) {
            data.push(TransactionType.REDEEM);
            data.push(TransactionType.REDEEM_ALL);
            data.push(TransactionType.EXCHANGE);
            data.push(TransactionType.EXCHANGE_ALL);

            data.push(TransactionType.SELL_AND_BUY);
            data.push(TransactionType.SELL_ALL_AND_BUY);
        }

        return data;
    }

}
